import { type FC, type PropsWithChildren } from 'react';
export type LeagueTime = {
  seconds: string;
  minutes: string;
  hours: string;
  days: string;
};

interface LeagueTimerProps extends PropsWithChildren {
  value: LeagueTime;
  text: string | undefined;
}

const LeagueTimer: FC<LeagueTimerProps> = ({ value, text }) => {
  const { minutes, hours, days } = value;

  return (
    <div className="flex flex-col items-center justify-center">
      {text && (
        <span className="text-gray-400 text-[10px] font-normal leading-[100%] tracking-normal">
          {text}
        </span>
      )}
      <span className="text-nowrap whitespace-nowrap">
        {Number(days) ? `${days}d : ${hours}h` : `${hours}h : ${minutes}m`}
      </span>
    </div>
  );
};

export { LeagueTimer };
